import { useAuthStore } from "../stores/authStore";
import { isAuthed } from "../models/authState";

export const useUserToken = () =>
  useAuthStore((state) => (isAuthed(state) ? state.session.token : undefined));
